export const iconFontAwesomeEditingCropSimple = (
	<i className="fa-solid fa-crop-simple"></i>
);
